import type { FacetCleanUpProps } from '../types/FacetCleanUpProps'

export const facetCleanUp = ({
  setSelectedFacets,
  setIndicesExpanded,
  setIsOpen,
  defaultFacets,
  term,
  base,
  sort,
}: FacetCleanUpProps) => {
  if (defaultFacets) {
    setSelectedFacets([...defaultFacets])

    const newSort = sort ?? 'score_desc'
    const urlRedirect = term
      ? `/s/?q=${term}&sort=${newSort}&page=0`
      : `${base}`

    if (
      `${window?.location?.origin}${urlRedirect}` !==
      decodeURIComponent(window?.location?.href)?.replaceAll(',', '%2C')
    ) {
      window.history.pushState({}, '', urlRedirect)
    }
  }

  setIndicesExpanded(new Set([]))
  setIsOpen(false)
}
